// extracted by mini-css-extract-plugin
export var tabs = "tabs-module--tabs--cvecY";
export var primary = "tabs-module--primary--2IgEo";
export var tab = "tabs-module--tab--2Zyal";
export var active = "tabs-module--active--133Mo";